import {
  Graticule,
  Group,
  Tile as TileLayer,
} from 'ol/layer'
import { TileDebug } from 'ol/source'

export const specialDebugLayers = new Group({
  title: 'Special/Debug',
  fold: 'open',
  layers: [
    new Graticule({
      title: 'Grid',
      showLabels: true,
      wrapX: false,
      visible: false,
    }),
    new TileLayer({
      title: 'Tile Debug',
      source: new TileDebug(),
      visible: false,
    }),
  ],
})
